module.exports = __webpack_public_path__ + "img/Unidad12-1.c3e2f215.png";